import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./assets/css/bootstrap.min.css";
import "./assets/css/font-awesome.min.css";
import "./assets/css/line-awesome.min.css";
import "./assets/css/style.css";
import MainLayout from "./layouts/MainLayout";
import { isMobile } from "react-device-detect";
import useNetworkStatus from "./hooks/useNetworkStatus";
import useDeviceTracking from "./hooks/useDeviceTracking";

// import Banner from "./pages/Banner";
import Employees from "./pages/Employees";
// import ErrorElement from "./pages/Error";
import Groups from "./pages/Groups";
import HistoryV2 from "./pages/HistoryV2";
import AssignReward from "./pages/AssignReward";
import Login from "./pages/Login";
import Logout from "./pages/LogOut";
import MicrosoftCallback from "./pages/MicrosoftCallback";
import NotFound from "./pages/NotFound";
import Redeem from "./pages/Redeem";
import Reports from "./pages/Reports";
import Reward from "./pages/Reward";
import UserDashboard from "./pages/UserDashboard";
import Userrewardhistory from "./pages/Userrewardhistory";
// import Anouncements from "./pages/Anouncements";

import NotCompatibleWithMobile from "./pages/NotCompatibleWithMobile";
import NetworkOffline from "./pages/NetworkOffline";
// Lazy load pages

function App() {
  const { isOnline } = useNetworkStatus();
  const minWidth = 1024; // Minimum width in pixels (iPad size)
  const deviceData = useDeviceTracking(minWidth);

  if (isMobile || !deviceData.isCompatible) {
    return <NotCompatibleWithMobile />;
  }

  if (!isOnline) {
    return <NetworkOffline />;
  }

  // Route configuration
  const routes = [
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/home",
      element: (
        <MainLayout>
          <UserDashboard />
        </MainLayout>
      ),
    },
    {
      path: "/auth/microsoft/*",
      element: <MicrosoftCallback />,
    },
    {
      path: "/rewards",
      element: (
        <MainLayout>
          <Reward />
        </MainLayout>
      ),
    },
    {
      path: "/rewards/users",
      element: (
        <MainLayout>
          <AssignReward />
        </MainLayout>
      ),
    },
    // {
    //   path: "/banners",
    //   element: (
    //     <MainLayout>
    //       <Banner />
    //     </MainLayout>
    //   ),
    // },
    {
      path: "/reports",
      element: (
        <MainLayout>
          <Reports />
        </MainLayout>
      ),
    },
    {
      path: "/history",
      element: (
        <MainLayout>
          <HistoryV2 />
        </MainLayout>
      ),
    },

    {
      path: "/groups",
      element: (
        <MainLayout>
          <Groups />
        </MainLayout>
      ),
    },
    {
      path: "/users",
      element: (
        <MainLayout>
          <Employees />
        </MainLayout>
      ),
    },
    {
      path: "/redeem",
      element: (
        <MainLayout>
          <Redeem />
        </MainLayout>
      ),
    },

    // {
    //   path: "/anouncements",
    //   element: (
    //     <MainLayout>
    //       <Anouncements />
    //     </MainLayout>
    //   ),
    // },

    {
      path: "/logout",
      element: <Logout />,
    }, // Logout does not need MainLayout and ErrorElement
    {
      path: "/rewards/history",
      element: (
        <MainLayout>
          <Userrewardhistory />
        </MainLayout>
      ),
    },
    {
      path: "*",
      element: <NotFound />,
    }, // NotFound does not need MainLayout and ErrorElement
  ];

  return (
    <>
      <Router>
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </Router>

      <ToastContainer
        stacked
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}
export default App;
